/**
 * Build a cURL example with credential placeholders only.
 */
export function buildSanitizedCurl({
  method = 'GET',
  url,
  authMode = 'bearer',
  headers = {},
  body,
  contentType = 'application/json',
}) {
  const lines = [`curl -X ${String(method).toUpperCase()} '${url}'`];

  if (authMode === 'apiKey' || authMode === 'apiKeyAuth') {
    lines.push(`  -H 'x-api-key: YOUR_API_KEY'`);
  } else {
    lines.push(`  -H 'Authorization: Bearer YOUR_BEARER_TOKEN'`);
  }

  Object.entries(headers || {}).forEach(([k, v]) => {
    const key = String(k).toLowerCase();
    if (['authorization', 'x-api-key', 'x-gateway-apikey', 'cookie'].includes(key)) return;
    if (v == null || v === '') return;
    lines.push(`  -H '${k}: ${String(v).replace(/'/g, `'\\''`)}'`);
  });

  if (body != null && !['GET', 'HEAD'].includes(String(method).toUpperCase())) {
    lines.push(`  -H 'Content-Type: ${contentType || 'application/json'}'`);
    const payload = typeof body === 'string' ? body : JSON.stringify(body, null, 2);
    lines.push(`  -d '${payload.replace(/'/g, `'\\''`)}'`);
  }

  return lines.join(' \\\n');
}

export function httpStatusHint(status) {
  const map = {
    400: 'Bad Request — check parameters and body against the OpenAPI contract.',
    401: 'Unauthorized — token missing, expired, or API key invalid.',
    403: 'Forbidden — authenticated but not permitted for this resource.',
    404: 'Not Found — path or resource does not exist.',
    409: 'Conflict — resource state conflict.',
    422: 'Validation Error — request failed schema/business validation.',
    429: 'Too Many Requests — rate limit exceeded; wait and retry safely.',
    500: 'Internal Server Error — server failed; do not retry mutations blindly.',
    502: 'Bad Gateway — upstream/gateway unavailable.',
    503: 'Service Unavailable — temporary outage.',
    504: 'Gateway Timeout — request exceeded timeout.',
  };
  return map[status] || null;
}
